const common = {
  home: '首页',
  category: '分类',
  ranking: '排行榜',
  latest: '最新',
  about: '关于我们',
  search: '搜索',
  watchNow: '立即观看',
  learnMore: '了解更多',
  viewAll: '查看全部',
  loadMore: '加载更多',
  noContent: '暂无内容',
  comingSoon: '更多内容正在制作中，敬请期待...',
  notFound: '内容未找到',
  backHome: '返回首页',
  copyright: '果冻传媒 版权所有',
  privacy: '隐私政策',
  terms: '用户协议',
  contact: '联系我们',
};

export default common;